; (function (jQuery) {

	"use strict";

	function MyCourses() {
		var fn = {
			init: function () {
				jQuery('.my-courses').each(function () {
					fn.initBlock(this);
				});
			},

			initBlock: function (block) {
				jQuery(block).find('[role="tab"]').on('click', function () {
					fn.activateTab.call(this, block);
				});
				jQuery(block).find('[role="tab"]').on('keydown', function (e) {
					fn.eventHandler.call(this, e, block);
				});
			},

			eventHandler: function (e, block) {
				const tabs = jQuery(block).find('[role="tab"]');
				const currentIndex = tabs.index(this);

				switch (e.key) {
					case 'ArrowRight':
						e.preventDefault();
						fn.focusTab(block, (currentIndex + 1) % tabs.length);
						break;

					case 'ArrowLeft':
						e.preventDefault();
						fn.focusTab(block, currentIndex === 0 ? tabs.length - 1 : currentIndex - 1);
						break;

					case 'Home':
						e.preventDefault();
						fn.focusTab(block, 0);
						break;

					case 'End':
						e.preventDefault();
						fn.focusTab(block, tabs.length - 1);
						break;
				}
			},

			focusTab: function (block, index) {
				jQuery(block).find('[role="tab"]').eq(index).trigger('focus');
			},

			activateTab: function (block) {
				const tab = jQuery(this);
				const tabs = jQuery(block).find('[role="tab"]');
				const panels = jQuery(block).find('[role="tabpanel"]');
				const targetPanelId = tab.attr('aria-controls');

				tabs.each(function () {
					const currentTab = jQuery(this);
					const isActive = currentTab.is(tab);

					currentTab
						.toggleClass('my-courses__tab--active', isActive)
						.attr('aria-selected', isActive ? 'true' : 'false')
						.attr('tabindex', isActive ? '0' : '-1');
				});

				panels.each(function () {
					const panel = jQuery(this);
					const isActivePanel = panel.attr('id') === targetPanelId;

					panel.toggleClass('my-courses__panel--active', isActivePanel);

					if (isActivePanel) {
						panel.removeAttr('hidden');
					}
					else {
						panel.attr('hidden', '');
					}
				});
			}
		};

		jQuery(document).ready(fn.init);
	}

	new MyCourses();

})(jQuery);